import React from 'react';
import { Text, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const UnitNumberCell = ({ values, row }) => {
  const { value, dataType } = values;
  const { original } = row;
  let notesHref = '';

  if (original?.company?.name === 'Enterprise Fleet Management') {
    // eslint-disable-next-line max-len
    notesHref = `https://enterprisefleetmanagement.cloud.looker.com/dashboards/snowflake_data::unit_notes_history?Group=&Branch=&Master+Customer+Number=&Customer+Number=&Unit+Number=${value ?? ''}&Employee+Name=&Note+Date=`;

    return (
      <Tooltip
        aria-label="Click to open legacy unit notes"
        label="Click to see unit's legacy notes on EFM Reports Center"
      >
        <a
          href={notesHref}
          rel="noreferrer"
          style={{ textDecoration: 'none' }}
          target="_blank"
        >
          <Text
            style={{ cursor: 'pointer' }}
            textAlign="center"
          >
            {value || ''}
          </Text>
        </a>
      </Tooltip>
    );
  }

  return (<Text>{value || ''}</Text>);
};

UnitNumberCell.propTypes = {
  values: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  row: PropTypes.shape({ original: PropTypes.shape({ id: PropTypes.number }) })
};

export default UnitNumberCell;
